import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Cushion, FlexContainer, Rectangle, Space, Typography } from '@pitchero/react-ui';
import { DateTime } from 'luxon';
import { Trans } from '../../../lib/i18n';

const DonationsList = ({ donations }) => {
  if (donations.length === 0) {
    return null;
  }

  return (
    <Space vertical="medium" component="div">
      <Space bottom="medium">
        <Typography component="div" preset="title" color="black">
          <Trans i18nKey="shop:recent_donations_header">Recent Donations</Trans>
        </Typography>
      </Space>
      {donations.map(({ amount, avatar, date, id, name, note }) => (
        <Rectangle borderBottom="thinMercury" key={id}>
          <Cushion vertical="small">
            <FlexContainer alignItems="flex-start">
              <Space right="medium" responsive={[{ maxWidth: 'palm', props: { right: 'small' } }]}>
                <Avatar image={avatar} alt={name} size={64} />
              </Space>
              <div style={{ flex: 1 }}>
                <Space bottom="xsmall">
                  <FlexContainer
                    justifyContent="space-between"
                    responsive={[{ maxWidth: 'palm', props: { flexDirection: 'column' } }]}
                  >
                    <Typography preset="subtitle--small">{name}</Typography>
                    <Typography preset="description" color="dovegrey">
                      {DateTime.fromISO(date).toFormat('d MMMM yyyy')}
                    </Typography>
                  </FlexContainer>
                </Space>
                {note && (
                  <Typography preset="body--small" component="div" color="dovegrey">
                    {note}
                  </Typography>
                )}
                <Space top="small">
                  <Typography component="div" preset="subtitle--large" color="primary">
                    {amount}
                  </Typography>
                </Space>
              </div>
            </FlexContainer>
          </Cushion>
        </Rectangle>
      ))}
    </Space>
  );
};
DonationsList.defaultProps = {
  donations: [],
};

DonationsList.propTypes = {
  donations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      date: PropTypes.string,
      amount: PropTypes.string,
      name: PropTypes.string,
      avatar: PropTypes.string,
      note: PropTypes.string,
    }),
  ),
};

export default DonationsList;
